document.addEventListener("DOMContentLoaded", function () {
  console.log("[Cart Cleanup] Initializing script to clear cart attributes properly.");

  function clearCartAttributes() {
    console.log("[Cart Cleanup] Attempting to remove cart attributes...");

    // Fetch the current cart to get existing attributes
    fetch("/cart.js")
      .then(response => response.json())
      .then(cart => {
        if (!cart.attributes || Object.keys(cart.attributes).length === 0) {
          console.log("[Cart Cleanup] No attributes to clear.");
          return;
        }

        // Build an object with all attributes set to null (to delete them)
        const clearedAttributes = {};
        Object.keys(cart.attributes).forEach(key => {
          clearedAttributes[`attributes[${key}]`] = null;
        });

        return fetch("/cart/update.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
          body: new URLSearchParams(clearedAttributes),
        });
      })
      .then(response => response ? response.json() : null)
      .then(data => {
        if (data) {
          console.log("[Cart Cleanup] Successfully cleared cart attributes:", data.attributes);
        }
      })
      .catch(error => {
        console.error("[Cart Cleanup] Failed to clear cart attributes:", error);
      });
  }

  // ✅ Clear attributes on /cart page load
  if (window.location.pathname === "/cart") {
    console.log("[Cart Cleanup] Detected /cart page. Clearing attributes.");
    clearCartAttributes();
  }

  // ✅ Clear attributes when going back from checkout
  window.addEventListener("pageshow", function (event) {
    console.log("[Cart Cleanup] pageshow event detected.");
    if (window.location.pathname === "/cart") {
      console.log("[Cart Cleanup] User returned to /cart. Clearing attributes.");
      clearCartAttributes();
    }
  });

  // ✅ Clear attributes when cart:updated event is fired
  document.addEventListener("cart:updated", function () {
    console.log("[Cart Cleanup] cart:updated event detected. Clearing attributes.");
    clearCartAttributes();
  });

  // ✅ Clear attributes when #edit-btn is clicked
  const editBtn = document.getElementById("edit-btn");
  if (editBtn) {
    editBtn.addEventListener("click", function () {
      console.log("[Cart Cleanup] #edit-btn clicked. Clearing attributes.");
      clearCartAttributes();
    });
  } else {
    console.warn("[Cart Cleanup] #edit-btn not found.");
  }
});